module.exports = __webpack_public_path__ + "static/media/menu-boczne-ustawienia_BLUE.6741ae77.svg";